import {createSelector} from 'reselect';
import authSelectors from 'src/modules/auth/authSelectors';
import PermissionChecker from 'src/modules/auth/permissionChecker';
import Permissions from 'src/security/permissions';

const selectPermissionToRead = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.employeeCategoryRead),
);

const selectPermissionToEdit = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.employeeCategoryEdit),
);

const selectPermissionToCreate = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.employeeCategoryCreate),
);

const selectPermissionToImport = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.employeeCategoryImport),
);

const selectPermissionToDestroy = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    new PermissionChecker(currentTenant, currentUser).match(Permissions.values.employeeCategoryDestroy),
);

const employeeCategorySelectors = {
  selectPermissionToRead,
  selectPermissionToEdit,
  selectPermissionToCreate,
  selectPermissionToDestroy,
  selectPermissionToImport,
};

export default employeeCategorySelectors;
